import { HttpMethod } from "@lib/http.helpers";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useApiRequest } from "./use-api-request";

export const isSnowplowEnabled =
  import.meta.env.SNOWPLOW_ENABLED?.toLowerCase() === "true";

export const ANALYTICS_EVENT_TYPES = {
  explore_new_career: "explore_new_career",
  test_network_connectivity_link: "click_test_network_connectivity_link",
};

export const useAnalyticsTracking = (eventType) => {
  const mutationFn = useApiRequest({
    url: "/analytics/event",
    method: HttpMethod.Post,
  });

  const mutation = useMutation({
    mutationKey: ["analytics-event", eventType],
    mutationFn: (data) => mutationFn({ data: { type: eventType, data } }),
  });

  // Return simple function that will track the event if snowplow is enabled
  return (...args) => {
    if (!isSnowplowEnabled) {
      return;
    }

    mutation.mutateAsync(...args);
  };
};

export const withAnalyticsTracking = (eventType, data, handler) => {
  const trackEvent = useAnalyticsTracking(eventType);

  return useCallback(
    async (...args) => {
      trackEvent(data);
      handler(...args);
    },
    [data, handler],
  );
};

export const usePublicAnalyticsTracking = (eventType) => {
  const mutationFn = useApiRequest({
    url: "/analytics/public-event",
    method: HttpMethod.Post,
  });

  const mutation = useMutation({
    mutationKey: ["public-analytics-event", eventType],
    mutationFn: (data) => mutationFn({ data: { type: eventType, data } }),
  });

  // Return simple function that will track the event if snowplow is enabled
  return (...args) => {
    if (!isSnowplowEnabled) {
      return;
    }

    mutation.mutateAsync(...args);
  };
};
